import { Component, Injector, ChangeDetectionStrategy } from '@angular/core';
import { I18n } from '@app/i18n/strings-keys';
import { AgRendererComponent } from 'ag-grid-angular';

@Component({
  changeDetection: ChangeDetectionStrategy.OnPush,
  selector: 'xea-button-renderer',
  templateUrl: './button-renderer.component.html',
  styleUrls: ['./button-renderer.component.scss'],
  standalone: false,
})
export class ButtonRendererComponent implements AgRendererComponent {
  public params = null;
  public buttonText = I18n.CommonActions.Select; // Default text

  public constructor(public injector: Injector) {}

  public refresh(): boolean {
    return false;
  }

  public agInit(params: any): void {
    this.params = params;
    // Use buttonText from params if provided, otherwise use default
    this.buttonText = params?.buttonText || this.buttonText;
  }

  public clickHandler(params) {
    this.params?.clickHandler(params);
  }
}
